export default __webpack_public_path__ + "static/media/hospedaje2024.b2e791b6.pdf";